import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { authService } from "../../services/authService";
import UserMenu from "../UserMenu";
import "./Header.css";

export function Header({ showDashboardLink = false, className = "" }) {
  const { isAuthenticated } = useAuth();
  const [registrationsEnabled, setRegistrationsEnabled] = useState(true);

  useEffect(() => {
    if (isAuthenticated) return;
    const check = async () => {
      try {
        const data = await authService.getRegistrationsSetting();
        setRegistrationsEnabled(!!data.registrations_enabled);
      } catch {
        setRegistrationsEnabled(true);
      }
    };
    check();
  }, [isAuthenticated]);

  return (
    <header className={`app-header ${className}`}>
      <Link to="/" className="header-logo-link">
        <div className="header-logo">
          <img
            src="/logos/examcat_logo.png"
            alt="Examcat"
            className="logo-image"
          />
        </div>
      </Link>
      <nav className="header-nav">
        {isAuthenticated ? (
          <UserMenu />
        ) : (
          <>
            <Link to="/login" className="nav-link">
              Sign In
            </Link>
            {registrationsEnabled && (
              <Link to="/register" className="nav-link">
                Sign Up
              </Link>
            )}
          </>
        )}
      </nav>
    </header>
  );
}
